const keyEnterPrevent = (event) => {
  if (event.key === "Enter") {
    event.preventDefault();
    return false;
  }
};

export default keyEnterPrevent;
